import { render } from "./hr-full-width.vue?vue&type=template&id=49ac319c&scoped=true"
const script = {}

import "./hr-full-width.vue?vue&type=style&index=0&id=49ac319c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ac319c"]])

export default __exports__